import React, { ComponentPropsWithRef, forwardRef } from 'react'
import styled from 'styled-components'

import useText from '../hooks/useText'

import InputWrapper from './InputWrapper'

interface ITextAreaProps extends ComponentPropsWithRef<'textarea'> {
    error?: string
    labelText?: string
    children?: React.ReactElement
    textCount?: number
    showTextCount?: boolean
}

const STextArea = styled.textarea`
    background: transparent;
    width: 100%;
    resize: none;
    border: unset;
    padding: 10px 15px;
    font-size: 16px;
    font-weight: 300;
    z-index: 1;

    &:not(:placeholder-shown),
    &:focus {
        & ~ label {
            font-size: 12px;
            top: -10px;
            background-color: white;
            border-radius: 2px;
            z-index: 1;
        }
    }
`

const TextArea = forwardRef<HTMLTextAreaElement, ITextAreaProps>((props, ref) => {
    const text = useText()
    return (
        <InputWrapper
            labelText={props.labelText}
            error={props.error}
            {...(props.showTextCount && {
                subtitle: text('msgTextAreaCounter', { textCount: props.textCount, maxLength: props.maxLength }),
            })}
            subtitlePosition="right"
        >
            <STextArea ref={ref} placeholder=" " {...props}>
                {props.children}
            </STextArea>
        </InputWrapper>
    )
})

export default TextArea
